export default __webpack_public_path__ + "static/media/candidates_dashboard.e77db877.svg";